import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserModule, Meta, MetaDefinition} from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ProvidersHomeComponent } from './components/provider/providers-home/providers-home.component';
import { ProvidersComponent } from './components/provider/providers/providers.component';
import { ProviderItemComponent } from './components/child-elements/provider-item/provider-item.component';
import { ProviderComponent } from './components/provider/provider/provider.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ProviderFieldComponent } from './components/child-elements/provider-field/provider-field.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NavigationBarComponent } from './components/navigation-bar/navigation-bar.component';
import { BasketComponent } from './components/basket/basket.component';
import { HistoryComponent } from './components/history/history.component';
import { LoadingComponent } from './components/child-elements/loading/loading.component';
import { ProviderInfoComponent } from './components/child-elements/provider-info/provider-info.component';
import { ChooseAbonentComponent } from './components/choose-abonent/choose-abonent.component';
import { CheckProviderComponent } from './components/check-provider/check-provider.component';
import { ReceiptComponent } from './components/receipt/receipt.component';
import { ModalComponent } from './components/child-elements/modal/modal.component';
import { RedirectComponent } from './components/redirect/redirect.component';

import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { BreadCrumbsComponent } from './components/bread-crumbs/bread-crumbs.component';
import { PopupComponent } from './components/popup/popup.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ProvidersHomeComponent,
    ProvidersComponent,
    ProviderItemComponent,
    ProviderComponent,
    NotFoundComponent,
    ProviderFieldComponent,
    NavigationBarComponent,
    BasketComponent,
    HistoryComponent,
    LoadingComponent,
    ProviderInfoComponent,
    ChooseAbonentComponent,
    CheckProviderComponent,
    ReceiptComponent,
    ModalComponent,
    RedirectComponent,
    BreadCrumbsComponent,
    PopupComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    })
  ],
  providers: [Meta],
  bootstrap: [AppComponent]
})
export class AppModule { }
